import type { TranslationKeys } from './en'

const de: TranslationKeys = {
    loading: 'Laden...',
    redirectingToLogin: 'Weiterleitung zur Anmeldung...',
    callEndpointAgain: 'Endpoint erneut aufrufen',
    language: 'Sprache',
    user: 'Benutzer',
    message: 'Nachricht',
    error: 'Ein Fehler ist aufgetreten',
    logout: 'Abmelden',
    navHome: 'Home',
    navQuestionnaires: 'Fragenbögen',
    navResults: 'Resultate',
    navStudieninfos: 'Studieninfos',
    navKontakt: 'Kontakt',
    navBenutzerprofil: 'Benutzerprofil',
    navAdmin: 'Benutzerverwaltung',
    navAudit: 'Audit Log',
    settingsTitle: 'Profileinstellungen',
    settingsDisplayName: 'Anzeigename',
    settingsEmail: 'E-Mail',
    settingsLanguage: 'Sprache',
    settingsSave: 'Änderungen speichern',
    settingsSaved: 'Erfolgreich gespeichert',
    notFoundTitle: 'Seite nicht gefunden',
    notFoundMessage: 'Die gesuchte Seite existiert nicht oder wurde verschoben.',
    notFoundBack: 'Zurück zur Startseite',
    validationDisplayNameMin: 'Anzeigename muss mindestens 2 Zeichen lang sein',
    validationEmailInvalid: 'Muss eine gültige E-Mail-Adresse sein',
    authErrorTitle: 'Authentifizierungsdienst nicht verfügbar',
}

export default de
